// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"3abaa388","997":"9b9970cf"}[chunkId] + ".chunk.css";
};